import { THEME } from '@common/constants/theme.constant';
import React from 'react';
import { css } from 'twin.macro';
import { IFieldProps } from './field.component';
import { SerializedStyles } from '@emotion/react';

export interface IFieldFooterProps {
    name: string;
    errorMessage?: IFieldProps['errorMessage'];
    helperText?: IFieldProps['helperText'];
    className?: string;
    footerCss?: SerializedStyles;
}
export const FieldFooter = ({ errorMessage, name, helperText, footerCss }: IFieldFooterProps): JSX.Element | null => {
    return errorMessage || helperText ? (
        <div data-testid={`field-footer-${name}`} className="field-footer" css={[styles.root, footerCss]}>
            {errorMessage ? <span css={styles.error}>{errorMessage}</span> : null}
            {helperText ? <div>{helperText}</div> : null}
        </div>
    ) : null;
};
const styles = {
    root: css`
        text-align: left;
        font-weight: 200;
        margin-top: 8px;
        font-size: ${THEME.BASE_FONT_SIZE};
    `,
    error: css`
        color: red;
    `,
};
